import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import dayjs from 'dayjs';

const API_URL = '/api';

const CategoryViewModal = ({ open, onClose, category }) => {
  const [createdByUser, setCreatedByUser] = useState(null);
  const [updatedByUser, setUpdatedByUser] = useState(null);

  useEffect(() => {
    if (open && category) {
      // Fetch created by user details
      if (category.CreatedBy) {
        fetchUserDetails(category.CreatedBy, setCreatedByUser);
      }
      // Fetch updated by user details
      if (category.UpdatedBy) {
        fetchUserDetails(category.UpdatedBy, setUpdatedByUser);
      }
    }
  }, [open, category]);

  const fetchUserDetails = async (userId, setUser) => {
    try {
      const response = await fetch(`${API_URL}/users/${userId}`);
      if (response.ok) {
        const userData = await response.json();
        setUser(userData);
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  };

  if (!open || !category) return null;

  const sections = [
    {
      title: 'Category Information',
      fields: [
        { label: 'Category Code', value: category.CategoryCode },
        { label: 'Category Name', value: category.CategoryName },
        { label: 'Description', value: category.Description || '-' },
        { label: 'Status', value: category.Status },
      ]
    },
    {
      title: 'Subcategory Information',
      fields: [
        { label: 'Number of Subcategories', value: category.SubcategoryCount || 0 },
      ]
    },
    {
      title: 'System Information',
      fields: [
        { 
          label: 'Created Date', 
          value: category.CreatedDate ? dayjs(category.CreatedDate).format('YYYY-MM-DD HH:mm') : '-' 
        },
        { 
          label: 'Updated Date', 
          value: category.UpdatedDate ? dayjs(category.UpdatedDate).format('YYYY-MM-DD HH:mm') : '-' 
        },
        { label: 'Created By', value: createdByUser?.FullName || createdByUser?.Username || category.CreatedBy || '-' },
        { label: 'Updated By', value: updatedByUser?.FullName || updatedByUser?.Username || category.UpdatedBy || '-' },
      ]
    }
  ];

 return (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 p-2 sm:p-4">
    <div className="bg-[#E5E1DA] rounded-2xl shadow-2xl w-full max-w-3xl p-4 sm:p-8 relative overflow-y-auto max-h-[90vh]">
      {/* Close Button */}
      <button
        className="absolute top-3 right-3 sm:top-4 sm:right-4 text-[#2b6777] hover:text-[#52ab98]"
        onClick={onClose}
      >
        <FaTimes size={18} className="sm:w-5 sm:h-5" />
      </button>

      {/* Title */}
      <h2 className="text-xl sm:text-2xl font-bold text-[#2b6777] mb-4 sm:mb-6 text-center">
        Category Details
      </h2>

      <div className="space-y-4 sm:space-y-6">
        {sections.map((section, index) => (
          <div key={index} className="bg-white rounded-xl p-4 sm:p-6">
            <h3 className="text-base sm:text-lg font-bold text-[#2b6777] mb-3 sm:mb-4">
              {section.title}
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
              {section.fields.map((field, fieldIndex) => (
                <div key={fieldIndex} className="flex flex-col">
                  <span className="text-xs sm:text-sm font-medium text-gray-600">
                    {field.label}
                  </span>
                  <span className="text-sm sm:text-base text-gray-900 mt-1">
                    {field.label === "Status" ? (
                      <span
                        className={`inline-block px-2 sm:px-3 py-0.5 sm:py-1 rounded-full text-xs font-bold shadow-sm ${
                          field.value === "Active"
                            ? "bg-[#52ab98] text-white"
                            : "bg-gray-300 text-gray-500"
                        }`}
                      >
                        {field.value}
                      </span>
                    ) : field.label === "Number of Subcategories" ? (
                      <span className="inline-block px-2 sm:px-3 py-0.5 sm:py-1 rounded-full text-xs font-bold bg-[#52ab98] text-white">
                        {field.value}
                      </span>
                    ) : (
                      field.value || "-"
                    )}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div className="mt-4 sm:mt-6 flex justify-end">
        <button
          className="px-3 sm:px-4 py-1.5 sm:py-2 rounded bg-[#52ab98] hover:bg-[#2b6777] text-white text-sm sm:text-base font-semibold shadow transition"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  </div>
);

};

export default CategoryViewModal; 